import styles from "./styles.module.scss";

const FiltersButton = ({ label, isActive, onClick }) => {
    return (
      <button
        className={`${styles.filtersBtn} ${isActive ? styles.active : ""}`}
        onClick={onClick}
      >
        {label}
      </button>
    );
  };
  
  export default FiltersButton;